import clsx from 'clsx';
import { EmailsSent, EmailsSentLabelMap } from '@airreading/common/data';
import { Badge } from '@/components/ui/badge';

interface EmailsSentBadgeProps {
  emailsSent: EmailsSent;
}

const EmailsSentColorMap: Record<EmailsSent, string> = {
  [EmailsSent.first_warning]: 'bg-[#DBEAFE] hover:bg-[#DBEAFE] text-[#2563EB]',
  [EmailsSent.maximum_limit]: 'bg-[#F3E8FF] hover:bg-[#F3E8FF] text-[#9333EA]',
  [EmailsSent.reassignment]: 'bg-[#FFE4E6] hover:bg-[#FFE4E6] text-[#E11D48]',
};

export const EmailsSentBadge = ({ emailsSent }: EmailsSentBadgeProps) => {
  return (
    <Badge className={clsx('p-1 rounded-[6px] text-[14px] text-center font-bold', EmailsSentColorMap[emailsSent])}>
      {EmailsSentLabelMap[emailsSent]}
    </Badge>
  );
};
